function DisposableCupSelected() {
    return (
        <svg width="53" height="52" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="26.25" cy="26" r="24.7" fill="#0D0F11" stroke="#0D0F11" strokeWidth="2.6"/>
            <path
                d="M18.6946 21.4444V20.3333V20C18.6946 19.2636 19.2915 18.6666 20.0279 18.6666H32.0279C32.7643 18.6666 33.3612 19.2636 33.3612 20V21.4444M19.7469 29.4999L20.4832 36.1468C20.558 36.8222 21.1289 37.3333 21.8085 37.3333H25.5463H27.1494H30.2475C30.927 37.3333 31.4979 36.8222 31.5727 36.1468L32.2919 29.6538"
                stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <path
                d="M20.03 18.4999V16.9999C20.03 15.8953 20.9255 14.9999 22.03 14.9999H30.0301C31.1346 14.9999 32.0301 15.8953 32.0301 16.9999V18.4999"
                stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M18.2498 22.222H34.2498C34.4337 22.222 34.5836 22.3711 34.5837 22.5551V28.7777C34.5837 28.9618 34.4338 29.1107 34.2498 29.1107H18.2498C18.0658 29.1105 17.9168 28.9616 17.9167 28.7777V22.5551L17.9236 22.4886C17.9545 22.3366 18.0887 22.2222 18.2498 22.222Z"
                stroke="white" strokeWidth="2" strokeLinejoin="round"/>
        </svg>
    );
}

export default DisposableCupSelected;
